import React, { useEffect, useState, Fragment } from "react";
import Loader from "../../UI/loader";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { sendAnalytics } from "../../../action/homeAction";
import { setRegPage } from "../../../action/action";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { setGoHome, setLoginRequired } from "../../action/homeAction";
import { CLICKED, CMSPath, EXIT } from "../../../config/constant";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { getAddonsForSpa, getSpaTreatmentList } from "../../../action/spaBooking";
import SuccessFailScreen from "../../UI/SuccessFailScreen";
import SpaBooking1 from "./spaBooking1";
import SpaBooking2 from "./spaBooking2";
import SpaBooking3 from "./spaBooking3";
import SpaBookingSuccess from "./spaBookingSuccess";
import { scrollToTop } from "../../../JS/scrollToTop";

const SpaBookingV2 = (props) => {
  const { t } = props;

  let room = localStorage.getItem("room");
  let label = getDefaultAnalyticsLabel({
    appVersion: props.installedAppVersion
      ? `${props.installedAppVersion}(${props.installedAppBuildNo})`
      : "",
  });
  let widgetSesstionId = localStorage.getItem("spaBookingSessionToken");

  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const [loading, setLoading] = useState(false);
  const [displayLoadingMsg, setDisplayLoadingMessage] = useState("");

  const [currentPage, setCurrentPage] = useState(null);

  const [spaData, setSpaData] = useState([]);
  const [spaLocationId, setSpaLocationId] = useState(null);

  const [serviceGroupData, setServiceGroupData] = useState([]);
  const [selectedService, setSelectedService] = useState(null);

  const [availableAddOns, setAvailableAddOns]= useState(null);
  const [selectedAddon, setSelectedAddon]=useState([]);
  const [showDeprecatedAddonWarning, setShowDeprecatedAddonWarning]=useState(false);
  const [deprecatedAddonList, setDeprecatedAddonList]=useState(null);

  const [successResponse, setSuccessResponse] = useState(null);
  const [updateReservationDetails, setUpdateReservationDetails] = useState(null)
  const [isAnyPrevReservForAnyLocation, setIsAnyPrevReservForAnyLocation] = useState(false);
  const [cachedApiDataStore, setCachedApiDataStore] = useState({}); //`my_reservations_${data.spalocationId}`

  const [chargesDetails, setChargesDetails] = useState({serviceCharge:0,tax:0});



  const handleServiceNextScreen2 = async (selectedDetails) => {
    console.log(selectedDetails, "servicedataa");
    setSelectedService(selectedDetails);
    const cb=()=>{
      setCurrentPage(3);
      }
       
    await fetchAddonService(selectedDetails.service.id,cb);

  };

  const handleLocationNextScreen1 = (spaLocationId) => {
    setSpaLocationId(spaLocationId);

    spaData.forEach((data) => {
      if (data.spalocationId == spaLocationId) {
        setServiceGroupData(data.serviceGroup);
      }
    });
    setCurrentPage(2.1);
  };

  const handleGoBack = () => {
    if (currentPage == 4) {
      restartSpaBookingFlow()
      return;
    }
    if (currentPage == 3) {
      if (updateReservationDetails) {
        setUpdateReservationDetails(null)
        setSelectedAddon([]);
        setAvailableAddOns(null);
        setCurrentPage(2.1);
        return;
      }
      setSelectedAddon([]);
      setAvailableAddOns(null);
      setCurrentPage(2.2);
      return;
    }

    if (currentPage >= 2 && currentPage < 3) {
      if (currentPage == 2.2) {
        setSelectedService(null)
        setCurrentPage(2.1)
        return;
      }
      if(props.currentWidgets.spaLocationId){
        props.setGoHome(true);
        return;
      }
      setCurrentPage(1)
      return;
    }

    props.setGoHome(true);
  };

  const fetchSpaTreatmentList = (location) => {
    setError(false);
    setLoading(true);

    getSpaTreatmentList(location)
      .then((res) => {
        if (res.status == 200 && (res && res.data && res.data.header && res.data.header.status && res.data.header.status.code == "SUCCESS")) {
          setSpaData(res && res.data && res.data.payload && res.data.payload.data);
          
          let charges_details={serviceCharge:0,tax:0};

          if(res.data.payload && res.data.payload.serviceCharge) charges_details.serviceCharge= res.data.payload.serviceCharge ;
          if(res.data.payload && res.data.payload.tax) charges_details.tax= res.data.payload.tax ;

          setChargesDetails(charges_details);

          setCurrentPage(1);
          setLoading(false);

          props.sendAnalytics(
            props.guestDetail,
            props.currentWidgets.widgetType,
            "FETCH SPA DATA - SUCCESS",
            {
              ...label,
              layoutTab: props.currentHomePage.tabName,
              element: "widget",
              widgetSessionId: widgetSesstionId,
            },
            0,
            props.guestIsLoggedIn
          );
        } else {
          setLoading(false);
          setError(true);
          setErrorMsg(
            res.response &&
            res.response.data.header &&
            res.response.data.header.status &&
            res.response.data.header.status.msg
          );

          props.sendAnalytics(
            props.guestDetail,
            props.currentWidgets.widgetType,
            "FETCH SPA DATA - ERROR",
            {
              ...label,
              layoutTab: props.currentHomePage.tabName,
              element: "widget",
              widgetSessionId: widgetSesstionId,
              errorStatus: (res && res.response)?res.response.status:"",
              errorMessage: JSON.stringify(res.response.data.header.status.msg),
            },
            0,
            props.guestIsLoggedIn
          );
        }
      })
      .catch((err) => {
        setLoading(false);
        setError(true);
      });
  };

  const fetchData = async (locationId) => {
    if (room && room != "null") {
      fetchSpaTreatmentList(locationId);
    } else {
      if (process.env.REACT_APP_INROOMTAB == "true") {
        props.setLoginRequired(true);
      } else {
        props.setRegPage(true);
      }
    }
  };

  const fetchAddonService= async (serviceId,successCb)=>{
    setLoading(true);

    const payload={
      "spaLocationId": Number(spaLocationId),
      "primaryServiceId": serviceId, 
    } 

   await getAddonsForSpa(payload)
    .then((res) => {
      if (res.status == 200 && (res && res.data && res.data.header && res.data.header.status && res.data.header.status.code == "SUCCESS")) {
        let availableAddon_=res && res.data && res.data.payload && res.data.payload.data;
        // if(isUpdateFlow) availableAddon_.reduce((acc,curr)=>{ acc.push({...curr,name:curr.serviceName}); return acc; },[])
        
        setAvailableAddOns(availableAddon_);
        
        setLoading(false);

        props.sendAnalytics(
          props.guestDetail,
          props.currentWidgets.widgetType,
          "FETCH SPA SERVICE ADDONS - SUCCESS",
          {
            ...label,
            layoutTab: props.currentHomePage.tabName,
            element: "widget",
            widgetSessionId: widgetSesstionId,
          },
          0,
          props.guestIsLoggedIn
        );
        successCb(availableAddon_);

      } else {
         
        setLoading(false);
        
        props.sendAnalytics(
          props.guestDetail,
          props.currentWidgets.widgetType,
          "FETCH SPA SERVICE ADDONS - ERROR",
          {
            ...label,
            layoutTab: props.currentHomePage.tabName,
            element: "widget",
            widgetSessionId: widgetSesstionId,
            errorStatus: (res&& res.response)? res.response.status:"",
            errorMessage: (res && res.data && res.data.header && res.data.header.status && res.data.header.status.msg)?  JSON.stringify(res.response.data.header.status.msg) :"",
          },
          0,
          props.guestIsLoggedIn
        );

        props.closeOrderPopUp(
          true,
          (res && res.data && res.data.header && res.data.header.status && res.data.header.status.msg)||
          res && res.response && res.response.data && res.response.data.header && res.response.data.header.status && res.response.data.header.status.msg||
          t("spaBooking.errors.error"),
          "",
          true
        );
      }
    })
    .catch((err) => {
      setLoading(false);
    });

  }
  const restartSpaBookingFlow = () => {

    let cachedData = cachedApiDataStore;
    const  key = `my_reservations_${spaLocationId}`;
    delete cachedData[key];
    setCachedApiDataStore(cachedData);

    setServiceGroupData([]);
    setSelectedService(null);
    setSuccessResponse(null);
    setUpdateReservationDetails(null)
    setSelectedAddon([]);
    setAvailableAddOns(null);
    if (spaLocationId){
      handleLocationNextScreen1(spaLocationId)
    }else {
      setCurrentPage(1);
    }
    // setIsAnyPrevReservForAnyLocation(false);
  }

  const handleReservationUpdateSuccess = () => {
    props.closeOrderPopUp(true, t('spaBooking.success.thank_you'), t('spaBooking.success.successful_res_update'), false);
    restartSpaBookingFlow();

  }

  const handleReservationSuccess = (res) => {
    setSuccessResponse(res);
    setCurrentPage(4);
  };

  const handleReservationUpdateNextToScreen3 = async (reservationDetails) => {

    console.log("reservatinDetail in main", reservationDetails)
    setUpdateReservationDetails(reservationDetails)
    let selectedService_ = {};
    const { serviceGroup } = spaData.find(d => d.spalocationId == spaLocationId);
    console.log(spaLocationId)
    console.log(spaData)
    console.log(serviceGroup);

    console.log("reservationDetails.serviceName", reservationDetails.serviceName)
    for (let index = 0; index < serviceGroup.length; index++) {
      const services = serviceGroup[index];
      const service = services.services.find(service => {
        console.log("service-name", service.id);
        return (service.id == reservationDetails.lines[0].serviceId)
        // return (service.name == reservationDetails.serviceName) || (service.name == reservationDetails.lines[0].serviceName)

      }) //"Excursion to the Lighthouse Island"} ) // reservationDetails.serviceName); // check if they can send id
      console.log('service', service)
      if (service) {
        selectedService_['name'] = services.name;
        selectedService_['service'] = service;
        break;

      }
    }



    console.log("on update, selectedServie:", selectedService_)

    if (Object.keys(selectedService_).length == 0) {
      props.closeOrderPopUp(true, t('spaBooking.No_record_found'), "", true);
      return
    }

     
    
    const cb=(availableAddon_)=>{
      console.log("availableAddon_",availableAddon_)
      setSelectedService(selectedService_);
      console.log("cb for fetchAddonService update")
      if(ifAnyDeprecatedAddon(availableAddon_,reservationDetails.lines[0].addOn)){

        setShowDeprecatedAddonWarning(true);

      }else{
        console.log("going to 3rd page")
        setCurrentPage(3)
      }
    }

    await fetchAddonService(selectedService_.service.id,cb);
    
  }
  const shouldProceedOnDeprecatedAddonsWarning=(shouldProceed)=>{
    if(shouldProceed){
      setCurrentPage(3)
    }else{
      setSelectedService(null);
      setUpdateReservationDetails(null)
    }
    setShowDeprecatedAddonWarning(false)
    setDeprecatedAddonList(null);
  }
   
  
  //return true/false
  const ifAnyDeprecatedAddon=(currentlyAvailableAddons, earlierSelectedAddons)=>{
      if(!earlierSelectedAddons){
        earlierSelectedAddons=[]
      }
      let selectedAddons_=[];
      let unMatchedAddons_=[];
      console.log("currentlyAvailableAddons",currentlyAvailableAddons)
      console.log("earlierSelectedAddons",earlierSelectedAddons)
      for( let addon of earlierSelectedAddons){
        
        const matchingAddon= currentlyAvailableAddons.find(addon_=> (addon_.id == addon.serviceId) && (addon_.price == addon.price))
        
        if(matchingAddon){
          selectedAddons_.push(matchingAddon)
        }else{
          unMatchedAddons_.push(addon);
        }
      }
      console.log(unMatchedAddons_,"unMatchedAddons_");
      console.log(selectedAddons_,"selectedAddons_")

      setSelectedAddon(selectedAddons_);
      if(unMatchedAddons_.length>0) setDeprecatedAddonList(unMatchedAddons_)

      return (unMatchedAddons_.length>0);
  }
   


  useEffect(() => {
    if (!loading) setDisplayLoadingMessage("");
  }, [loading]);

  useEffect(() => {
    scrollToTop();
    // If the widget is for the "Spa location," then set the spaLocationId to fetch data corresponding to that location.
    console.log(props.currentWidgets, "currentWidgts@");
    console.log("room?", room);

    if (props.currentWidgets.spaLocationId)
      {setSpaLocationId(props.currentWidgets.spaLocationId);}
      
      fetchData(props.currentWidgets.spaLocationId);
       

    if (!localStorage.getItem("spaBookingClicked")) {
      props.sendAnalytics(
        props.guestDetail,
        props.currentWidgets.widgetType,
        CLICKED,
        {
          ...label,
          layoutTab: props.currentHomePage.tabName,
          element: "widget",
          widgetSessionId: widgetSesstionId,
        },
        0,
        props.guestIsLoggedIn,
        () => localStorage.setItem("spaBookingClicked", true)
      );
    }

    return () => {
      props.sendAnalytics(
        props.guestDetail,
        props.currentWidgets.widgetType,
        EXIT,
        {
          ...label,
          layoutTab: props.currentHomePage.tabName,
          element: "widget",
          widgetSessionId: widgetSesstionId,
        },
        0,
        props.guestIsLoggedIn
      );
    };
  }, []);


 

  return (
    <Fragment>
      {currentPage != 3 &&
        <header className="inner-pages w-footer subpages">
          <a className="button-back" onClick={() => handleGoBack()}></a>
          <div className="heading align-center">
            <div class="splash-brand">
              <img src={`${CMSPath}${props.logo}`} />
            </div>
          </div>
        </header>
      }
      <section className="widgets padding-0 margin-0 container-bg">
        {error ? (
          <SuccessFailScreen
            status={false}
            showTryAgain={true}
            showClose={true}
            statusMessage1={t(`spaBooking.errors.error`)}
            statusMessage2={
              errorMsg || t("spaBooking.errors.unable_process_request")
            }
            close={props.setGoHome}
            tryAgain={() => fetchData()}
          />
        ) : currentPage == 1 ? (
          <SpaBooking1
            spaData={spaData}
            next={(spaLocationId) => handleLocationNextScreen1(spaLocationId)}
            goBack={() => handleGoBack()}
          />
        ) : (currentPage >= 2 && currentPage < 3) ? (
          <SpaBooking2
            currentPage={currentPage}
            spaData={spaData}
            handleReservationUpdateNextToScreen3={handleReservationUpdateNextToScreen3}
            spaLocationId={spaLocationId}
            serviceGroupData={serviceGroupData}
            nextToScreen2_2={() => { setCurrentPage(2.2) }}
            nextToScreen3={async (serviceData) => await handleServiceNextScreen2(serviceData)}
            selectedService={selectedService}

            deprecatedAddonList={deprecatedAddonList}
            showDeprecatedAddonWarning={showDeprecatedAddonWarning}
            shouldProceedOnDeprecatedAddonsWarning={shouldProceedOnDeprecatedAddonsWarning}

            setIsAnyPrevReservForAnyLocation={setIsAnyPrevReservForAnyLocation}
            cachedApiDataStore={cachedApiDataStore}
            setCachedApiDataStore={setCachedApiDataStore}
            goBack={() => handleGoBack()}
          />
        ) : currentPage == 3 ? (
          <SpaBooking3
            spaLocationId={spaLocationId}
            serviceGroupData={serviceGroupData}
            selectedService={selectedService}
            availableAddOns={ availableAddOns}
            selectedAddon={ selectedAddon}
            setSelectedAddon={setSelectedAddon}
            updateReservationDetails={updateReservationDetails}
            chargesDetails={chargesDetails}
            handleReservationSuccess={handleReservationSuccess}
            isAnyPrevReservForAnyLocation={isAnyPrevReservForAnyLocation}
            handleReservationUpdateSuccess={handleReservationUpdateSuccess}
            goBack={() => handleGoBack()}
          />
        ) : currentPage == 4 ? (
          <SpaBookingSuccess
            selectedService={selectedService}
            successResponse={successResponse}
            updateReservationDetails={updateReservationDetails}
            next={() => {
              handleGoBack();
            }}
          />
        ) : null}
      </section>
      {loading && <Loader displayMsg={displayLoadingMsg} />}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    logo: state.store.home.currentDuration.brandingInfo
      ? state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl
      : "",
    currentHomePage: state.store2.currentHomePage,
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    guestDetail: state.store.home.guestDetails,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    currentWidgets: state.store.sideNavBar.currentWidget,
  };
};

export default connect(mapStateToProps, {
  setGoHome,
  closeOrderPopUp,
  setRegPage,
  setLoginRequired,
  sendAnalytics,
})(withTranslation("translations")(SpaBookingV2));
